<script>
import PagesListView from '../PagesList.vue';

export default {
  components: {
    PagesListView: PagesListView,
  },
};
</script>

<template>
  <PagesListView post-header="Reels" post-type="reel" />
</template>
